<template>
  <p class="resources__read-time" v-if="resource.resConsumptionTime && resource.resConsumptionTimeMeasurement">
  {{ resource.resConsumptionTime }} {{ resource.resConsumptionTimeMeasurement }}<span class="visuallyhidden" v-if="resource.resConsumptionTimeMeasurement === 'min'">ute</span><template v-if="resource.resConsumptionTime > 1">s</template>
  </p>
</template>
<script>
export default {
  data() {
    return {}
  },
  props: {
    resource: {
      type: Object,
      required: true
    }
  },
  methods: {}
}
</script>
